<template>
  <span>
    <button
      v-if="mode == 'new'"
      class="btn btn-success btn-rounded px-4 rounded-pill"
      v-b-modal="'dailyTaskModal' + _uid"
    >
      <i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új feladat
    </button>
    <button
      v-else
      class="btn btn-primary btn-sm"
      v-b-modal="'dailyTaskModal' + _uid"
      title="szerkesztés"
    >
      <i class="fa fa-pencil fa-xs"></i>
    </button>
    <b-modal
      size="xl"
      :id="'dailyTaskModal' + _uid"
      cancel-variant="default"
      @cancel="closeDailyTaskModal()"
      @ok="formHandler"
      ok-title="Mentés"
      cancel-title="Mégse"
      :ok-disabled="loading"
    >
      <template slot="modal-header">
        <h4 class="modal-title">
          {{
            mode === "new"
              ? "Új feladat létrehozása"
              : "Feladat szerkesztése - " + dailyTask.id + ". számú feladat"
          }}
        </h4>
        <a class="btn-close" @click="closeDailyTaskModal()"></a>
      </template>
      <form @submit.prevent="formHandler()">
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">Üzem</label>
              <v-select
                v-if="locations"
                v-model="form.location_id"
                :options="locations"
                :reduce="(o) => o.id"
                label="name"
                :clearable="false"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                    :placeholder="form.location_id == null ? 'Válassz' : ''"
                  />
                </template>
              </v-select>
              <loading mini v-else />
              <div v-if="errors.location_id" class="invalid-feedback d-block">
                {{ errors.location_id[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">Munkavégző</label>
              <v-select
                v-if="available_workers"
                v-model="form.worker_id"
                :reduce="(o) => o.id"
                :options="available_workers"
                label="name"
                :clearable="false"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                    :placeholder="form.worker_id == null ? 'Válassz' : ''"
                  />
                </template>
              </v-select>
              <loading mini v-else />
              <div v-if="errors.worker_id" class="invalid-feedback d-block">
                {{ errors.worker_id[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">Megnevezés</label>
              <input type="text" class="form-control" v-model="form.name" />
              <div v-if="errors.name" class="invalid-feedback d-block">
                {{ errors.name[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">Felelős</label>
              <v-select
                v-if="users"
                v-model="form.user_id"
                :options="users"
                :reduce="(o) => o.id"
                label="name"
                :clearable="false"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                    :placeholder="form.user_id == null ? 'Válassz' : ''"
                  />
                </template>
              </v-select>
              <loading mini v-else />
              <div v-if="errors.user_id" class="invalid-feedback d-block">
                {{ errors.user_id[0] }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">PM rendelés</label>
              <input
                type="text"
                class="form-control"
                v-model="form.pm_order_number"
              />
              <div
                v-if="errors.pm_order_number"
                class="invalid-feedback d-block"
              >
                {{ errors.pm_order_number[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">eSafety mf. száma:</label>
              <v-select
                v-if="available_tasks"
                v-model="form.task_id"
                :options="available_tasks"
                :reduce="(o) => o.id"
                label="name"
                :clearable="false"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                    :placeholder="form.task_id == null ? 'Válassz' : ''"
                  />
                </template>
              </v-select>
              <loading mini v-else />
              <div v-if="errors.task_id" class="invalid-feedback d-block">
                {{ errors.task_id[0] }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">Munkavégzés jellege</label>
              <v-select
                v-if="responsible_departments"
                v-model="form.responsible_department_id"
                :options="responsible_departments"
                :reduce="(o) => o.id"
                label="name"
                :clearable="false"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                    :placeholder="
                      form.responsible_department_id == null ? 'Válassz' : ''
                    "
                  />
                </template>
              </v-select>
              <loading mini v-else />
              <div
                v-if="errors.responsible_department_id"
                class="invalid-feedback d-block"
              >
                {{ errors.responsible_department_id[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">Műszak:</label>
              <div class="form-group">
                <label v-for="shift in 3" :key="shift">
                  <input type="checkbox" :value="shift" v-model="form.shifts" />
                  {{ shift }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </span>
</template>

<script>
import DailyTask from "../../../apis/DailyTask";
import Loading from "../../../components/Loading";
import moment from "moment";

export default {
  components: { Loading },
  props: [
    "mode",
    "dailyTask",
    "locations",
    "users",
    "partners",
    "responsible_departments",
    "available_tasks",
  ],
  data() {
    return {
      loading: false,
      form: {},
      errors: [],
      now: moment().format("YYYY-MM-DD"),
    };
  },
  computed: {
    available_workers() {
      if (this.locations && this.partners) {
        return this.locations
          .filter((l) => l.parent_id == null)
          .map((l) => ({
            id: "location_" + l.id,
            name: l.name,
            partner: 0,
          }))
          .concat(
            this.partners.map((p) => ({
              id: "partner_" + p.id, //mivel egybe kell rakni a partnereket és a locationöket így tudom őket megkülönböztetni
              name: p.name,
              partner: 1,
            }))
          );
      } else {
        return false;
      }
    },
  },
  created() {
    this.fillForm();
  },
  watch: {
    dailyTask() {
      this.fillForm();
    },
  },
  methods: {
    closeDailyTaskModal() {
      this.$bvModal.hide("dailyTaskModal" + this._uid);
    },
    formHandler(bvModalEvt) {
      if (bvModalEvt) {
        //ok gombra van csak event
        bvModalEvt.preventDefault();
      }

      let methodToCall;
      let methodArguments;

      if (this.mode === "new") {
        methodToCall = DailyTask.add;
        methodArguments = [this.form];
      } else if (this.mode === "edit") {
        methodToCall = DailyTask.update;
        methodArguments = [this.dailyTask.id, this.form];
      }

      methodToCall(...methodArguments)
        .then((response) => {
          this.closeDailyTaskModal();
          if (this.mode == "new") {
            this.form = {
              name: null,
              location_id: null,
              worker_id: null,
              user_id: null,
              pm_order_number: null,
              responsible_department_id: null,
              task_id: null,
              shifts: [],
            };
            this.$emit("created", response.data);
          } else {
            this.$emit("saved");
          }
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        });
    },
    fillForm() {
      this.form =
        this.mode === "new"
          ? {
              name: null,
              location_id: null,
              worker_id: null,
              user_id: null,
              pm_order_number: null,
              shifts: [],
              responsible_department_id: null,
              task_id: null,
            }
          : this.dailyTask;
    },
  },
};
</script>
